
import axios from 'axios'
import { rutas } from '../rutas/rutas';

export const signin = (username, handleLogin, parametros) =>{
    try {
        
        window.hive_keychain.requestHandshake(finishSignin(username, handleLogin, parametros));
        //account-menu, login-box
    }
    catch (err) {
        console.log("keychain not installed")
        //show modal with link to keychain website or "new to hive" info page
    }
}

function finishSignin(username, handleLogin, parametros = "") {
    
    const message = Date.now().toString()
    try {
        window.hive_keychain.requestSignBuffer(
            username,
            message,
            "Posting",
            function (response) {
                if (response.error) {
                    
                 
                } else {
                    let username = response.data.username
                    
                    axios.post(rutas.login, {nombre: username, key: response.result, message, parametros})
                    .then(res=> {
                        const token = res.data?.token
                        document.cookie = `token=${token}; max-age=${3600 * 12}; path=/; samesite=strict; secure=true;`
                        handleLogin(res.data)
                      
                    })
                    .catch(err=> console.log(err))
                    //localStorage.setItem('username', username);
                  
               
                }
            }
        );
    }
    catch (e) {
        console.log(e)
    }
}
export function buy_nfts(nfts, price, priceSymbol, message) {
    let buy_multiple_nft = {
        "contractName": "nftmarket",
        "contractAction": "buy",
        "contractPayload": {
            "symbol": "NFTHUESO",
            "nfts": [nfts],
            "expPrice": price.toString(),
            "expPriceSymbol": priceSymbol.toString(),
            "marketAccount": "kingofduels"
        }
    }

    const username = JSON.parse(sessionStorage.getItem('user'))

        window.hive_keychain.requestCustomJson(username.user, "ssc-mainnet-hive", "Active", JSON.stringify(buy_multiple_nft), message, function (response) {
            console.log(response)
            if (response.success && response.result) {
                //show modal
            } else {
                //show modal
            }
        });
}
export function cancel_nft_sell(nfts) {
    let cancel_nft_listing = {
        "contractName": "nftmarket",
        "contractAction": "cancel",
        "contractPayload": {
            "symbol": "NFTHUESO",
            "nfts":[nfts]
        }
    }
    const username = JSON.parse(sessionStorage.getItem('user'))
  
    window.hive_keychain.requestCustomJson(username.user, "ssc-mainnet-hive", "Active", JSON.stringify(cancel_nft_listing), 'Cancel NFT Sell Listing?', function (response) {
        if (response.success && response.result) {
            //show modal
        } else {
            //show modal
        }
    });
}

export function sell_nft(nft, price, priceSymbol, message) {


    let buy_nft = {
        "contractName": "nftmarket",
        "contractAction": "sell",
        "contractPayload": {
            "symbol": "NFTHUESO",
            "nfts": [nft.toString()],
            "price": price.toString(),
            "priceSymbol": priceSymbol.toString(),
            "marketAccount": "mv-deposito",
            "fee": 500
        }
    }

    const username = JSON.parse(sessionStorage.getItem('user'))

        window.hive_keychain.requestCustomJson(username.user, "ssc-mainnet-hive", "Active", JSON.stringify(buy_nft), "Vender NFT", function (response) {
           console.log(response)
            if (response.success && response.result) {
                //show modal
            } else {
                //show modal
            }
        });

}